document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.nav-menu');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  var searchInput = document.getElementById('predictive-search-input');
  var resultsBox = document.getElementById('predictive-search-results');
  var debounceTimer;

  if (searchInput && resultsBox) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        resultsBox.style.display = 'none';
        resultsBox.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length === 0) {
              resultsBox.innerHTML = '<div style="padding:1rem; color:var(--color-text-muted); font-size:.9rem;">لا توجد نتائج</div>';
              resultsBox.style.display = 'block';
              return;
            }
            resultsBox.innerHTML = products.map(function (p) {
              var img = p.featured_image ? p.featured_image.url : '';
              return '<a href="' + p.url + '" style="display:flex; align-items:center; gap:.75rem; padding:.6rem 1rem; border-bottom:1px solid var(--color-border);">' +
                (img ? '<img src="' + img + '" alt="" style="width:38px; height:50px; object-fit:cover; border-radius:3px; flex-shrink:0;">' : '') +
                '<span style="flex:1; font-size:.9rem; color:var(--color-text);">' + p.title + '</span>' +
                '<span style="color:var(--color-gold-light); font-size:.85rem; white-space:nowrap;">' + p.price + '</span>' +
                '</a>';
            }).join('');
            resultsBox.style.display = 'block';
          })
          .catch(function () {
            resultsBox.style.display = 'none';
          });
      }, 300);
    });

    document.addEventListener('click', function (e) {
      if (!resultsBox.contains(e.target) && e.target !== searchInput) {
        resultsBox.style.display = 'none';
      }
    });
  }

  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var btn = form.querySelector('[data-add-to-cart-btn]');
      var originalText = btn ? btn.textContent : '';

      if (btn) {
        btn.textContent = 'جارٍ الإضافة...';
        btn.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (btn) {
            btn.textContent = 'تمت الإضافة ✓';
          }
          updateCartCount();
          setTimeout(function () {
            if (btn) {
              btn.textContent = originalText;
              btn.disabled = false;
            }
          }, 1800);
        })
        .catch(function () {
          if (btn) {
            btn.textContent = 'خطأ، حاول مجدداً';
            btn.disabled = false;
          }
        });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }
});
